<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-button
        v-if="
          $store.state.user_obj.account_type == 'admin' ||
            $store.state.user_obj.account_type == 'cs'
        "
        class="btn-action mb-3"
        size="sm"
        variant="info"
        :to="{ name: 'tracking_edit', params: { id: tracking.id } }"
        >Edit</b-button
      >

      <b-button
        v-if="$store.state.user_obj.account_type == 'young_living'"
        class="btn-action mb-3"
        size="sm"
        variant="info"
        :to="{
          name: 'change_request_edit',
          params: { tracking_id: tracking.id }
        }"
        >Raise Delivery Case</b-button
      >

      <b-button
        v-if="$store.state.user_obj.account_type == 'young_living'"
        class="btn-action mb-3"
        size="sm"
        variant="info"
        :to="{
          name: 'change_request_edit',
          params: { tracking_id: tracking.id }
        }"
        >Raise Non-Delivery Case</b-button
      >

      <b-card class="mb-1">
        <b-row>
          <b-col class="col-2">
            <strong>Courier name</strong>
          </b-col>
          <b-col>{{ tracking.courier_short_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Client name</strong>
          </b-col>
          <b-col>{{ tracking.client_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Tracking #</strong>
          </b-col>
          <b-col>{{ tracking.tracking_number }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Status</strong>
          </b-col>
          <b-col>{{ tracking.status }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Schedule Date</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.reschedule_delivery_date">{{
              displayDate(tracking.schedule_date)
            }}</span>
            <span v-if="tracking.reschedule_delivery_date"
              >{{ tracking.reschedule_type }}
              {{ displayDate(tracking.reschedule_delivery_date) }}</span
            >
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Attention</strong>
          </b-col>
          <b-col>
            <span v-if="!tracking.attention_driver">{{
              tracking.attention
            }}</span>
            <span v-if="tracking.attention_driver">{{
              tracking.attention_driver
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Remark</strong>
          </b-col>
          <b-col>{{ tracking.remark }}</b-col>
        </b-row>

        <b-row v-if="tracking.extra_fee">
          <b-col class="col-2">
            <strong>Extra Fee</strong>
          </b-col>
          <b-col
            >${{ tracking.extra_fee }} ({{ tracking.extra_fee_comment }})</b-col
          >
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>POD</strong>
          </b-col>
          <b-col>
            <!-- <a
              v-if="tracking.pod_image"
              :href="tracking.pod_image"
              target="_blank"
            >{{tracking.pod_type}}</a> -->
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              v-if="tracking.pod_image"
              @click="showPod(tracking)"
              >{{ tracking.pod_type }}</b-button
            >
            <span v-if="!tracking.pod_image">/</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Carried by</strong>
          </b-col>
          <b-col>
            <!-- <span v-if="$store.state.user_obj.account_type != 'young_living'">
              {{ tracking.carried_by }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'young_living'">
              Driver
            </span> -->

            <span v-if="tracking.carried_by && tracking.carried_by != ''">
              <span v-if="$store.state.user_obj.account_type != 'young_living'">
                {{ tracking.carried_by }}
              </span>
              <span v-if="$store.state.user_obj.account_type == 'young_living'">
                <span v-if="tracking.carried_by_type == 'driver'">
                  Driver
                </span>
                <span v-if="tracking.carried_by_type != 'driver'">
                  {{ tracking.carried_by_name }}
                </span>
              </span>
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Last Updated</strong>
          </b-col>
          <b-col>{{ tracking.updated_at }}</b-col>
        </b-row>

        <barcode
          :value="tracking.tracking_number"
          format="CODE128"
          height="50"
          width="2"
          display-value="false"
          flat="true"
          >Rendering failed.</barcode
        >
      </b-card>

      <h4
        class="mt-3"
        v-if="
          $store.state.user_obj.account_type == 'admin' ||
            $store.state.user_obj.account_type == 'cs' ||
            $store.state.user_obj.account_type == 'young_living'
        "
      >
        Status History
      </h4>

      <b-card>
        <b-table
          v-if="
            $store.state.user_obj.account_type == 'admin' ||
              $store.state.user_obj.account_type == 'cs' ||
              $store.state.user_obj.account_type == 'young_living'
          "
          responsive
          small
          outlined
          striped
          hover
          :items="history_items"
          :fields="history_fields"
        >
          <template slot="status" slot-scope="data">
            {{ data.item.status }}
            <span v-if="data.item.status_reason"
              >- {{ data.item.status_reason }}</span
            >
            <span v-if="data.item.other_reason">
              <br />
              [{{ data.item.other_reason }}]
            </span>

            <span v-if="data.item.reschedule_delivery_date">
              <br />
              [{{ data.item.reschedule_delivery_date }}]
            </span>
          </template>

          <template slot="updated_by" slot-scope="data">
            <span v-if="$store.state.user_obj.account_type != 'young_living'">
              {{ data.item.updated_by_name }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'young_living'">
              <span v-if="data.item.updated_by_type == 'driver'">
                Driver
              </span>
              <span v-if="data.item.updated_by_type != 'driver'">
                {{ data.item.updated_by_name }}
              </span>
            </span>
          </template>

          <template slot="pod_image" slot-scope="data">
            <a
              v-if="data.item.pod_image"
              :href="data.item.pod_image"
              target="_blank"
              >{{ data.item.pod_type }}</a
            >
            <span v-if="!data.item.pod_image">/</span>
          </template>

          <template slot="action" slot-scope="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="showModal_cancelTracking(data.item)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </b-card>

      <h4 class="mt-3">Delivery Case</h4>
      <b-card>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="cr_items"
          :fields="cr_fields"
        >
          <template slot="status" slot-scope="data">{{
            data.item.status
          }}</template>

          <template slot="changes" slot-scope="data">
            <div
              style="max-width: 200px; white-space: pre-line; word-break: break-word;"
            >{{ data.item.from_val }} -> {{ data.item.to_val }}
              <div v-if="data.item.other_reason">
                [{{ data.item.other_reason }}]
              </div>
              <div
                v-if="
                  data.item.reschedule_date &&
                    data.item.reschedule_date != '0000-00-00 00:00:00'
                "
              >
                [{{ data.item.reschedule_date }}]
              </div>
            </div>
          </template>

          <template slot="remark" slot-scope="data">
            <div
              style="max-width: 200px; white-space: pre-line; word-break: break-word;"
            >
              {{ data.item.remark }}
            </div>
          </template>

          <template slot="updated_at" slot-scope="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template slot="action" slot-scope="data">
            <b-button
              v-if="
                ($store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'cs') &&
                  data.item.status == 'pending'
              "
              class="btn-action"
              size="sm"
              variant="success"
              @click.stop="executeCR(data.item)"
              >Execute</b-button
            >

            <b-button
              v-if="data.item.status == 'pending'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="cancelCR(data.item)"
              >Cancel</b-button
            >
          </template>
        </b-table>
      </b-card>

      <h4 class="mt-3">Non-Delivery Case</h4>

      <cs-issue-card
        :key="item_index"
        v-for="(item, item_index) in items"
        :item="item"
        mode="view"
      ></cs-issue-card>

      <b-modal ref="modal_cancelTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to delete status?</strong>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="col-2">
              <strong>Date:</strong>
            </b-col>
            <b-col>{{ updating_item.updated_at }}</b-col>
          </b-row>

          <b-row>
            <b-col class="col-2">
              <strong>Status:</strong>
            </b-col>
            <b-col>{{ updating_item.status }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_cancelTracking"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="deleteTrackingStatus()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

import CsIssue_Card from "../components/CsIssue_Card.vue";

export default {
  name: "TrackingDetailOther",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card
  },
  data() {
    return {
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Trackings",
          to: { name: "trackings" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      cr_items: [],
      cr_fields: [
        {
          key: "tracking_number",
          label: "Tracking#"
        },
        {
          key: "remark",
          label: "Remark"
        },
        {
          key: "field_name",
          label: "Field Name"
        },
        {
          key: "changes",
          label: "Changes"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "created_by",
          label: "Requested By"
        },
        {
          key: "created_at",
          label: "Submitted at"
        },
        {
          key: "updated_by",
          label: "Executed By"
        },
        {
          key: "updated_at",
          label: "Executed at"
        },
        {
          key: "action",
          label: "Action"
        }
      ],

      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        },
        {
          key: "action",
          label: "Action"
        }
      ],
      loader: false,
      items: [{ id: false }],
      tracking: { id: false },
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: ""
    };
  },
  async created() {
    await this.getTracking();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getTracking() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          tracking_id: this.$route.params.id,
          account_type: this.$store.state.user_obj.account_type,
          other_courier: true
        }
      });
      this.tracking = response.data.trackings[0];
      this.items.push(this.tracking);

      this.history_items = response.data.tracking_status_historys;
      this.loader.hide();

      this.getChangeRequests();
      this.getCsIssues();
    },

    async getChangeRequests() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_get.php",
        data: {
          search_criteria: {
            tracking_number: this.tracking.tracking_number
          }
        }
      });
      this.cr_items = response.data.change_requests;
      this.loader.hide();
    },

    async executeCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_execute.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.getTracking();
        this.getChangeRequests();
      } else {
        alert(response.data.error_msg);
      }
    },

    async cancelCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_cancel.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.getChangeRequests();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    returnTracking(item) {
      this.updateTracking(item.order_id, "Returned to Warehouse", null, null);
    },

    rescheduleTracking() {
      this.updateTracking(
        this.updating_item.order_id,
        "Rescheduled",
        this.reschedule_type_selected,
        this.reschedule_date
      );
    },

    onManualReturnToWarehouse() {
      this.updateTracking(
        this.manual_return_order_id,
        "Returned to Warehouse",
        null,
        null
      );
    },

    async updateTracking(
      order_id,
      status,
      reschedule_delivery_type,
      reschedule_delivery_date
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_update.php",
        data: {
          order_id: order_id,
          status: status,
          reschedule_type: reschedule_delivery_type,
          reschedule_delivery_date: reschedule_delivery_date,
          user_id: "0"
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${order_id} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      } else {
      }

      this.getTracking();
      this.$refs.modal_reschedule_tracking.hide();
    },

    showModal_cancelTracking(item) {
      this.updating_item = item;
      this.$refs.modal_cancelTracking.show();
    },

    hideModal_cancelTracking() {
      this.$refs.modal_cancelTracking.hide();
    },

    async deleteTrackingStatus() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_status_delete.php",
        data: {
          tracking_id: this.tracking.id,
          tracking_status_id: this.updating_item.id,
          status: this.updating_item.status,
          date: this.updating_item.date
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${order_id} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      }

      this.getTracking();
      this.hideModal_cancelTracking();
    },

    showPod(item) {
      this.$eventHub.$emit("show_image_view", {
        image_url: item.pod_image,
        order_ids: item.order_ids,
        pod_at: item.pod_at
      });
    },

    async getCsIssues() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: {
            tracking_id: this.tracking.id
          }
        }
      });
      this.items = response.data.cs_issues;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingDetailOther.vue